(function () {
  const displayElement = document.getElementById('pet-names-display');
  if (!displayElement) return;

  // Escape function to prevent XSS
  const escapeHTML = (str) => {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  };

  try {
    const petsData = localStorage.getItem('pets');
    const pets = petsData ? JSON.parse(petsData) : [];

    if (Array.isArray(pets) && pets.length > 0) {
      const firstTwoNames = pets.slice(0, 2).map(pet => pet.name).filter(name => name);
      if (firstTwoNames.length === 2) {
        displayElement.innerHTML = `How is <a href="https://petmarketnyc.com/pages/pet-profile">${escapeHTML(firstTwoNames[0])}</a> and <a href="https://petmarketnyc.com/pages/pet-profile">${escapeHTML(firstTwoNames[1])}</a> doing today? 👋`;
        displayElement.classList.add('visible');
      } else if (firstTwoNames.length === 1) {
        displayElement.innerHTML = `How is <a href="https://petmarketnyc.com/pages/pet-profile">${escapeHTML(firstTwoNames[0])}</a> doing today? 👋`;
        displayElement.classList.add('visible');
      } else {
        displayElement.innerHTML = `<a href="https://petmarketnyc.com/pages/pet-profile">Add your pet!</a>`;
        displayElement.classList.add('visible');
      }
    } else {
      displayElement.innerHTML = `<a href="https://petmarketnyc.com/pages/pet-profile">Add your pet!</a>`;
      displayElement.classList.add('visible');
    }
  } catch (error) {
    console.error('Error parsing pets from localStorage:', error);
    displayElement.innerHTML = `<a href="https://petmarketnyc.com/pages/pet-profile">Add your pet!</a>`;
    displayElement.classList.add('visible');
  }
})();

